import { axios } from "~/plugins/request";

export const state = () => {
  return {};
};
export const mutations = {};
export const actions = {
  baseUniversityOpportunityList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/baseUniversityOpportunity/list`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selectUniversityByopportunityTypeId({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/opportunityProgramme/selectUniversityByopportunityTypeId`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateSchemeDesignThought({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/updateSchemeDesignThought`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  insertOpportunityProgramme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/insert`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selOpportunityProgrammeList({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/select`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  selOpportunityProgrammeById({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/selectById`, { schemeId: params })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  updateOpportunityProgramme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/update`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  deleteOpportunityProgramme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/delete`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  saveLeaveMessage({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/opportunityProgramme/saveLeaveMessage`, params)
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  },
  sendScheme({ commit }, params) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/opportunityProgramme/sendScheme`, {
          params
        })
        .then(response => {
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    });
  }
};
